var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833336 7.99992C0.833336 4.05711 4.05719 0.833252 8 0.833252C11.9428 0.833252 15.1667 4.05711 15.1667 7.99992C15.1667 11.9427 11.9428 15.1666 8 15.1666C4.05719 15.1666 0.833336 11.9427 0.833336 7.99992ZM8 1.83325C4.60948 1.83325 1.83334 4.60939 1.83334 7.99992C1.83334 11.3904 4.60948 14.1666 8 14.1666C11.3905 14.1666 14.1667 11.3904 14.1667 7.99992C14.1667 4.60939 11.3905 1.83325 8 1.83325Z",
    fill: "#7DD9AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99792 4.49992C8.27406 4.49992 8.49792 4.72378 8.49792 4.99992V8.33325C8.49792 8.60939 8.27406 8.83325 7.99792 8.83325C7.72178 8.83325 7.49792 8.60939 7.49792 8.33325V4.99992C7.49792 4.72378 7.72178 4.49992 7.99792 4.49992Z",
    fill: "#7DD9AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32735 10.9999C7.32735 10.6317 7.62582 10.3333 7.99401 10.3333H8C8.36819 10.3333 8.66667 10.6317 8.66667 10.9999C8.66667 11.3681 8.36819 11.6666 8 11.6666H7.99401C7.62582 11.6666 7.32735 11.3681 7.32735 10.9999Z",
    fill: "#7DD9AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.d0b819da84fbc59c2910f270e7015825.svg";
export { ForwardRef as ReactComponent };